import React from 'react';
import './style.scss';
import { Link } from 'react-router-dom';
import useUpdatePassword from './hooks';
import Form from '../../../components/molecules/forms';
import Button from '../../../components/molecules/buttons';
import AuthContainer from '../index';

function UpdatePassword(): React.ReactElement {
  const {
    navigateToLogin, isLoading, formik,
  } = useUpdatePassword();
  return (
    <AuthContainer
      title="Update Password"
      description="Lorem ipsum dolor sit amet constercts ipsum sit amet dolor lorum"
      onBack={navigateToLogin}
    >
      <form
        aria-label="form"
        onSubmit={formik.handleSubmit}
        className="form-container"
      >
        <Form.Default
          id="password"
          label="Password"
          placeholder="Enter password"
          value={formik.values.password}
          onChange={formik.handleChange}
          className="mb-4"
          isInvalid={formik.touched.password && !!formik.errors.password}
          errorMsg={formik.errors.password}
          onBlur={formik.handleBlur}
          type="password"
          validation
        />
        <Form.Default
          id="confirmPassword"
          label="Password"
          placeholder="Confirm password"
          value={formik.values.confirmPassword}
          onChange={formik.handleChange}
          className="mb-4"
          isInvalid={formik.touched.confirmPassword && !!formik.errors.confirmPassword}
          errorMsg={formik.errors.confirmPassword}
          onBlur={formik.handleBlur}
          type="password"
          validation
        />
        <div className="mt-5">
          <Button.Default
            id="submitLogin"
            type="submit"
            label="Update"
            className="fw-bold"
            loading={isLoading}
          />
        </div>
      </form>

    </AuthContainer>
  );
}

export default UpdatePassword;
